<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane :label="$t('tab.main_plan_edit')">
        <QTHDistributionEdit></QTHDistributionEdit>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.main_plan_view')">
        <QTHDistributionSearch></QTHDistributionSearch>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.pre_distribution')">
        <PreDistribution></PreDistribution>
      </el-tab-pane>
      <!-- <el-tab-pane :label="$t('tab.pre_distribution_changed_apply')">
        <PreDistributionChangedApply></PreDistributionChangedApply>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
import QTHDistributionEdit from './QTHDistributionEdit.vue';
import QTHDistributionSearch from './QTHDistributionSearch.vue';
import PreDistribution from './PreDistribution.vue';
import PreDistributionChangedApply from './PreDistributionChangedApply.vue';

export default {
  components: {
    QTHDistributionEdit,
    QTHDistributionSearch,
    PreDistribution,
    PreDistributionChangedApply
  },
  data() {
    return {
      tab_index: "0"
    }
  },
  mounted() {
    let href = window.location.href.split("?")
    if (href.length > 0) {
      if (href[1] && href[1] == "tab=2") {
        this.tab_index = "1"
      }
    }
  }
}
</script>
